import script from "./TexturedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TexturedCard.vue?vue&type=script&setup=true&lang=js"

import "./TexturedCard.vue?vue&type=style&index=0&id=eaef6e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaef6e4c"]])

export default __exports__